<template>
  <div class="modal fade" id="modal-new-program">
    <div class="modal-dialog modal-dialog-l">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
          <h4 class="modal-title">{{$t('trainings.description.title')}}</h4>
        </div>
        <div v-if="currentTraining != null" class="modal-body">
          <div v-if="isCabinet()" class="box">
            <AddTrainingComponent
              v-bind:current-camp="currentCamp"
              v-bind:sport-types="sportTypes"
              v-bind:countries="countries"
              v-bind:cities="sortedCities"
              v-bind:language="$root.$i18n.locale"
              v-bind:current-training="currentTraining">
            </AddTrainingComponent>
          </div>
          <div v-else class="box">
            <div class="row">
              <div class="col-md-6">
                <AddTrainingComponent
                  v-bind:current-camp="currentCamp"
                  v-bind:sport-types="sportTypes"
                  v-bind:countries="countries"
                  v-bind:cities="sortedCities"
                  v-bind:language="'en'"
                  v-bind:current-training="currentTraining">
                </AddTrainingComponent>
              </div>
              <div class="col-md-6">
                <AddTrainingComponent
                  v-bind:current-camp="currentCamp"
                  v-bind:sport-types="sportTypes"
                  v-bind:countries="countries"
                  v-bind:cities="sortedCities"
                  v-bind:language="'ru'"
                  v-bind:current-training="currentTraining">
                </AddTrainingComponent>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default pull-left" data-dismiss="modal">{{$t('button.close')}}</button>
          <button v-on:click="saveTraining" type="button" class="btn btn-primary">{{$t('button.save-changes')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddTrainingComponent from './AddTraining';
import axios from 'axios';

export default {
  name: 'AddTraining',
  props: {
    currentCamp: Object,
    sportTypes: Array,
    countries: Array
  },
  components: {
    AddTrainingComponent
  },
  created () {
    let self = this;

    this.$root.$on('selectCamp', this.selectCurrentCamp);

    self.$root.$on('changeCountry', function (countryId) {
      self.changeCountry(countryId);
    });
  },
  data () {
    return {
      currentTraining: {
        id: '',
        name:
            {
              ru: '',
              en: ''
            },
        description: {
          en: '',
          ru: ''
        },
        sportType: {
          id: ''
        },
        age: {
          minAge: '',
          maxAge: ''
        },
        location: {
          countryId: '',
          cityId: '',
          address: {
            en: '',
            ru: ''
          }
        }
      },
      cities: []
    };
  },
  updated () {
    // eslint-disable-next-line no-undef
    $('.box').boxWidget();
  },
  computed: {
    sortedCities: function () {
      var sortedCities = this.cities;

      sortedCities.sort(function (a, b) {
        if (a.name.en < b.name.en) { return -1; }
        if (a.name.en > b.name.en) { return 1; }
        return 0;
      });
      return sortedCities;
    }
  },
  methods: {
    isCabinet: function () {
      return window.application === 'cabinet';
    },
    saveTraining: function () {
      var self = this;

      var q = [];

      if (self.currentTraining.qualificationAmateur) {
        q.push(1);
      }

      if (self.currentTraining.qualificationProfessional) {
        q.push(2);
      }

      console.log(self.currentCamp.id);

      var savedTraining =
          {
            'campId': self.currentCamp.id,
            'name': self.currentTraining.name,
            'sportTypeId': self.currentTraining.sportType.id,
            'minAge': self.currentTraining.age.minAge,
            'maxAge': self.currentTraining.age.maxAge,
            'qualification': q,
            'description': self.currentTraining.description,
            'parameters': {
              en: '',
              ru: ''
            },
            'video': self.currentTraining.video,
            'location': {
              'countryId': self.currentTraining.location.countryId,
              'cityId': self.currentTraining.location.cityId,
              'address': self.currentTraining.location.address
            }
          };

      axios.post(
        window.host + '/sport-programs', savedTraining)
        .then(function (response) {
          console.log(response.data);
          self.$root.$emit('alert', 'success', 'alert.success');

          document.location.reload(true);
        })
        .catch(function (error) {
          console.log(error);
          self.$root.$emit('alert', 'error', 'alert.error');
        });
    },
    changeCountry: function (countryId) {
      let self = this;

      axios.get(
        window.host + '/countries/' + countryId + '/cities')
        .then(function (response) {
          console.log(response.data);
          self.cities = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }
};
</script>

<style>
  .modal-dialog-l {
    width: 80%;
  }

  .wysihtml5-toolbar {
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    padding-left: 0;
  }

  textarea.editor {
    width: 100%;
    height: 400px;
  }

  .input-group {
    width: 100%;
  }

  .editr {
    border: 1px solid #e4e4e4;
    width: 100%;
  }

  .editr--toolbar {
    background: #f6f6f6;
    border-bottom: 1px solid #e4e4e4;
    position: relative;
    display: flex;
    height: 32px;
  }

  .editr--toolbar a {
    display: inline-block;
    width: 8vw;
    max-width: 32px;
    height: 32px;
    color: #333;
    fill: #333;
    cursor: pointer;
    text-align: center;
    line-height: 1;
  }

  .editr--toolbar a:hover {
    background: rgba(0, 0, 0, 0.1);
  }

  .editr--toolbar a:active {
    background: rgba(0, 0, 0, 0.2);
  }

  .editr--toolbar a svg {
    width: 16px;
    height: 16px;
    margin: 8px auto;
  }

  .editr--toolbar a svg path {
    fill: inherit;
  }

  .editr--toolbar a.vw-btn-separator {
    width: 1px;
    margin: 0 8px;
  }

  .editr--toolbar a.vw-btn-separator:hover {
    background: initial;
    cursor: default;
  }

  .editr--toolbar a.vw-btn-separator i.vw-separator {
    border-left: 1px solid rgba(0, 0, 0, 0.1);
    height: 100%;
    position: absolute;
    width: 1px;
  }

  .editr--toolbar .dashboard {
    width: 100%;
    position: absolute;
    top: 32px;
    left: 0;
    text-align: left;
    padding: 8px 16px;
    background: rgba(255, 255, 255, 0.95);
    border: 1px solid #f6f6f6;
  }

  .editr--content {
    min-height: 150px;
    padding: 12px 8px 16px 8px;
    line-height: 1.33;
    font-family: inherit;
    color: inherit;
    overflow-y: auto;
  }

  .editr--content[contenteditable=true]:empty:before {
    content: attr(placeholder);
    color: rgba(0, 0, 0, 0.3);
    display: block; /* For Firefox */
  }

  .editr--content img {
    max-width: 100%;
  }

  .editr--content table {
    width: 100%;
    border-collapse: collapse;
  }

  .editr--content table th {
    text-align: left;
  }

  .editr--content table th,
  .editr--content table td {
    border: 1px solid #ddd;
    padding: 2px;
  }

  .editr--content:focus {
    outline: 0;
  }

  .editr--content ul li,
  .editr--content ol li {
    list-style-position: inside;
  }

  @media screen and (max-width: 320px) {
    .editr--toolbar a {
      margin: 0 2px;
    }

    .editr--toolbar a.vw-btn-separator {
      display: none;
    }
  }

  /*
   * The MIT License
   * Copyright (c) 2012 Matias Meno <m@tias.me>
   */
  @-webkit-keyframes passing-through {
    0% {
      opacity: 0;
      -webkit-transform: translateY(40px);
      -moz-transform: translateY(40px);
      -ms-transform: translateY(40px);
      -o-transform: translateY(40px);
      transform: translateY(40px);
    }
    30%, 70% {
      opacity: 1;
      -webkit-transform: translateY(0px);
      -moz-transform: translateY(0px);
      -ms-transform: translateY(0px);
      -o-transform: translateY(0px);
      transform: translateY(0px);
    }
    100% {
      opacity: 0;
      -webkit-transform: translateY(-40px);
      -moz-transform: translateY(-40px);
      -ms-transform: translateY(-40px);
      -o-transform: translateY(-40px);
      transform: translateY(-40px);
    }
  }

  @-moz-keyframes passing-through {
    0% {
      opacity: 0;
      -webkit-transform: translateY(40px);
      -moz-transform: translateY(40px);
      -ms-transform: translateY(40px);
      -o-transform: translateY(40px);
      transform: translateY(40px);
    }
    30%, 70% {
      opacity: 1;
      -webkit-transform: translateY(0px);
      -moz-transform: translateY(0px);
      -ms-transform: translateY(0px);
      -o-transform: translateY(0px);
      transform: translateY(0px);
    }
    100% {
      opacity: 0;
      -webkit-transform: translateY(-40px);
      -moz-transform: translateY(-40px);
      -ms-transform: translateY(-40px);
      -o-transform: translateY(-40px);
      transform: translateY(-40px);
    }
  }

  @keyframes passing-through {
    0% {
      opacity: 0;
      -webkit-transform: translateY(40px);
      -moz-transform: translateY(40px);
      -ms-transform: translateY(40px);
      -o-transform: translateY(40px);
      transform: translateY(40px);
    }
    30%, 70% {
      opacity: 1;
      -webkit-transform: translateY(0px);
      -moz-transform: translateY(0px);
      -ms-transform: translateY(0px);
      -o-transform: translateY(0px);
      transform: translateY(0px);
    }
    100% {
      opacity: 0;
      -webkit-transform: translateY(-40px);
      -moz-transform: translateY(-40px);
      -ms-transform: translateY(-40px);
      -o-transform: translateY(-40px);
      transform: translateY(-40px);
    }
  }

  @-webkit-keyframes slide-in {
    0% {
      opacity: 0;
      -webkit-transform: translateY(40px);
      -moz-transform: translateY(40px);
      -ms-transform: translateY(40px);
      -o-transform: translateY(40px);
      transform: translateY(40px);
    }
    30% {
      opacity: 1;
      -webkit-transform: translateY(0px);
      -moz-transform: translateY(0px);
      -ms-transform: translateY(0px);
      -o-transform: translateY(0px);
      transform: translateY(0px);
    }
  }

  @-moz-keyframes slide-in {
    0% {
      opacity: 0;
      -webkit-transform: translateY(40px);
      -moz-transform: translateY(40px);
      -ms-transform: translateY(40px);
      -o-transform: translateY(40px);
      transform: translateY(40px);
    }
    30% {
      opacity: 1;
      -webkit-transform: translateY(0px);
      -moz-transform: translateY(0px);
      -ms-transform: translateY(0px);
      -o-transform: translateY(0px);
      transform: translateY(0px);
    }
  }

  @keyframes slide-in {
    0% {
      opacity: 0;
      -webkit-transform: translateY(40px);
      -moz-transform: translateY(40px);
      -ms-transform: translateY(40px);
      -o-transform: translateY(40px);
      transform: translateY(40px);
    }
    30% {
      opacity: 1;
      -webkit-transform: translateY(0px);
      -moz-transform: translateY(0px);
      -ms-transform: translateY(0px);
      -o-transform: translateY(0px);
      transform: translateY(0px);
    }
  }

  @-webkit-keyframes pulse {
    0% {
      -webkit-transform: scale(1);
      -moz-transform: scale(1);
      -ms-transform: scale(1);
      -o-transform: scale(1);
      transform: scale(1);
    }
    10% {
      -webkit-transform: scale(1.1);
      -moz-transform: scale(1.1);
      -ms-transform: scale(1.1);
      -o-transform: scale(1.1);
      transform: scale(1.1);
    }
    20% {
      -webkit-transform: scale(1);
      -moz-transform: scale(1);
      -ms-transform: scale(1);
      -o-transform: scale(1);
      transform: scale(1);
    }
  }

  @-moz-keyframes pulse {
    0% {
      -webkit-transform: scale(1);
      -moz-transform: scale(1);
      -ms-transform: scale(1);
      -o-transform: scale(1);
      transform: scale(1);
    }
    10% {
      -webkit-transform: scale(1.1);
      -moz-transform: scale(1.1);
      -ms-transform: scale(1.1);
      -o-transform: scale(1.1);
      transform: scale(1.1);
    }
    20% {
      -webkit-transform: scale(1);
      -moz-transform: scale(1);
      -ms-transform: scale(1);
      -o-transform: scale(1);
      transform: scale(1);
    }
  }

  @keyframes pulse {
    0% {
      -webkit-transform: scale(1);
      -moz-transform: scale(1);
      -ms-transform: scale(1);
      -o-transform: scale(1);
      transform: scale(1);
    }
    10% {
      -webkit-transform: scale(1.1);
      -moz-transform: scale(1.1);
      -ms-transform: scale(1.1);
      -o-transform: scale(1.1);
      transform: scale(1.1);
    }
    20% {
      -webkit-transform: scale(1);
      -moz-transform: scale(1);
      -ms-transform: scale(1);
      -o-transform: scale(1);
      transform: scale(1);
    }
  }

  .dropzone, .dropzone * {
    box-sizing: border-box;
  }

  .dropzone {
    min-height: 150px;
    border: 2px solid rgba(0, 0, 0, 0.3);
    background: white;
    padding: 20px 20px;
  }

  .dropzone.dz-clickable {
    cursor: pointer;
  }

  .dropzone.dz-clickable * {
    cursor: default;
  }

  .dropzone.dz-clickable .dz-message, .dropzone.dz-clickable .dz-message * {
    cursor: pointer;
  }

  .dropzone.dz-started .dz-message {
    display: none;
  }

  .dropzone.dz-drag-hover {
    border-style: solid;
  }

  .dropzone.dz-drag-hover .dz-message {
    opacity: 0.5;
  }

  .dropzone .dz-message {
    text-align: center;
    margin: 2em 0;
  }

  .dropzone .dz-preview {
    position: relative;
    display: inline-block;
    vertical-align: top;
    margin: 16px;
    min-height: 100px;
  }

  .dropzone .dz-preview:hover {
    z-index: 1000;
  }

  .dropzone .dz-preview:hover .dz-details {
    opacity: 1;
  }

  .dropzone .dz-preview.dz-file-preview .dz-image {
    border-radius: 20px;
    background: #999;
    background: linear-gradient(to bottom, #eee, #ddd);
  }

  .dropzone .dz-preview.dz-file-preview .dz-details {
    opacity: 1;
  }

  .dropzone .dz-preview.dz-image-preview {
    background: white;
  }

  .dropzone .dz-preview.dz-image-preview .dz-details {
    -webkit-transition: opacity 0.2s linear;
    -moz-transition: opacity 0.2s linear;
    -ms-transition: opacity 0.2s linear;
    -o-transition: opacity 0.2s linear;
    transition: opacity 0.2s linear;
  }

  .dropzone .dz-preview .dz-remove {
    font-size: 14px;
    text-align: center;
    display: block;
    cursor: pointer;
    border: none;
  }

  .dropzone .dz-preview .dz-remove:hover {
    text-decoration: underline;
  }

  .dropzone .dz-preview:hover .dz-details {
    opacity: 1;
  }

  .dropzone .dz-preview .dz-details {
    z-index: 20;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    font-size: 13px;
    min-width: 100%;
    max-width: 100%;
    padding: 2em 1em;
    text-align: center;
    color: rgba(0, 0, 0, 0.9);
    line-height: 150%;
  }

  .dropzone .dz-preview .dz-details .dz-size {
    margin-bottom: 1em;
    font-size: 16px;
  }

  .dropzone .dz-preview .dz-details .dz-filename {
    white-space: nowrap;
  }

  .dropzone .dz-preview .dz-details .dz-filename:hover span {
    border: 1px solid rgba(200, 200, 200, 0.8);
    background-color: rgba(255, 255, 255, 0.8);
  }

  .dropzone .dz-preview .dz-details .dz-filename:not(:hover) {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .dropzone .dz-preview .dz-details .dz-filename:not(:hover) span {
    border: 1px solid transparent;
  }

  .dropzone .dz-preview .dz-details .dz-filename span, .dropzone .dz-preview .dz-details .dz-size span {
    background-color: rgba(255, 255, 255, 0.4);
    padding: 0 0.4em;
    border-radius: 3px;
  }

  .dropzone .dz-preview:hover .dz-image img {
    -webkit-transform: scale(1.05, 1.05);
    -moz-transform: scale(1.05, 1.05);
    -ms-transform: scale(1.05, 1.05);
    -o-transform: scale(1.05, 1.05);
    transform: scale(1.05, 1.05);
    -webkit-filter: blur(8px);
    filter: blur(8px);
  }

  .dropzone .dz-preview .dz-image {
    border-radius: 20px;
    overflow: hidden;
    width: 120px;
    height: 120px;
    position: relative;
    display: block;
    z-index: 10;
  }

  .dropzone .dz-preview .dz-image img {
    display: block;
  }

  .dropzone .dz-preview.dz-success .dz-success-mark {
    -webkit-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);
    -moz-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);
    -ms-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);
    -o-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);
    animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);
  }

  .dropzone .dz-preview.dz-error .dz-error-mark {
    opacity: 1;
    -webkit-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);
    -moz-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);
    -ms-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);
    -o-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);
    animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);
  }

  .dropzone .dz-preview .dz-success-mark, .dropzone .dz-preview .dz-error-mark {
    pointer-events: none;
    opacity: 0;
    z-index: 500;
    position: absolute;
    display: block;
    top: 50%;
    left: 50%;
    margin-left: -27px;
    margin-top: -27px;
  }

  .dropzone .dz-preview .dz-success-mark svg, .dropzone .dz-preview .dz-error-mark svg {
    display: block;
    width: 54px;
    height: 54px;
  }

  .dropzone .dz-preview.dz-processing .dz-progress {
    opacity: 1;
    -webkit-transition: all 0.2s linear;
    -moz-transition: all 0.2s linear;
    -ms-transition: all 0.2s linear;
    -o-transition: all 0.2s linear;
    transition: all 0.2s linear;
  }

  .dropzone .dz-preview.dz-complete .dz-progress {
    opacity: 0;
    -webkit-transition: opacity 0.4s ease-in;
    -moz-transition: opacity 0.4s ease-in;
    -ms-transition: opacity 0.4s ease-in;
    -o-transition: opacity 0.4s ease-in;
    transition: opacity 0.4s ease-in;
  }

  .dropzone .dz-preview:not(.dz-processing) .dz-progress {
    -webkit-animation: pulse 6s ease infinite;
    -moz-animation: pulse 6s ease infinite;
    -ms-animation: pulse 6s ease infinite;
    -o-animation: pulse 6s ease infinite;
    animation: pulse 6s ease infinite;
  }

  .dropzone .dz-preview .dz-progress {
    opacity: 1;
    z-index: 1000;
    pointer-events: none;
    position: absolute;
    height: 16px;
    left: 50%;
    top: 50%;
    margin-top: -8px;
    width: 80px;
    margin-left: -40px;
    background: rgba(255, 255, 255, 0.9);
    -webkit-transform: scale(1);
    border-radius: 8px;
    overflow: hidden;
  }

  .dropzone .dz-preview .dz-progress .dz-upload {
    background: #333;
    background: linear-gradient(to bottom, #666, #444);
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 0;
    -webkit-transition: width 300ms ease-in-out;
    -moz-transition: width 300ms ease-in-out;
    -ms-transition: width 300ms ease-in-out;
    -o-transition: width 300ms ease-in-out;
    transition: width 300ms ease-in-out;
  }

  .dropzone .dz-preview.dz-error .dz-error-message {
    display: block;
  }

  .dropzone .dz-preview.dz-error:hover .dz-error-message {
    opacity: 1;
    pointer-events: auto;
  }

  .dropzone .dz-preview .dz-error-message {
    pointer-events: none;
    z-index: 1000;
    position: absolute;
    display: block;
    display: none;
    opacity: 0;
    -webkit-transition: opacity 0.3s ease;
    -moz-transition: opacity 0.3s ease;
    -ms-transition: opacity 0.3s ease;
    -o-transition: opacity 0.3s ease;
    transition: opacity 0.3s ease;
    border-radius: 8px;
    font-size: 13px;
    top: 130px;
    left: -10px;
    width: 140px;
    background: #be2626;
    background: linear-gradient(to bottom, #be2626, #a92222);
    padding: 0.5em 1.2em;
    color: white;
  }

  .dropzone .dz-preview .dz-error-message:after {
    content: '';
    position: absolute;
    top: -6px;
    left: 64px;
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid #be2626;
  }

  .vue-dropzone {
    border: 2px solid #E5E5E5;
    font-family: 'Arial', sans-serif;
    letter-spacing: 0.2px;
    color: #777;
    transition: background-color 0.2s linear;
  }

  .vue-dropzone:hover {
    background-color: #F6F6F6;
  }

  .vue-dropzone i {
    color: #CCC;
  }

  .vue-dropzone .dz-preview .dz-image {
    border-radius: 0;
    width: 100%;
    height: 100%;
  }

  .vue-dropzone .dz-preview .dz-image img:not([src]) {
    width: 200px;
    height: 200px;
  }

  .vue-dropzone .dz-preview .dz-image:hover img {
    transform: none;
    -webkit-filter: none;
  }

  .vue-dropzone .dz-preview .dz-details {
    bottom: 0;
    top: 0;
    color: white;
    background-color: rgba(33, 150, 243, 0.8);
    transition: opacity .2s linear;
    text-align: left;
  }

  .vue-dropzone .dz-preview .dz-details .dz-filename {
    overflow: hidden;
  }

  .vue-dropzone .dz-preview .dz-details .dz-filename span,
  .vue-dropzone .dz-preview .dz-details .dz-size span {
    background-color: transparent;
  }

  .vue-dropzone .dz-preview .dz-details .dz-filename:not(:hover) span {
    border: none;
  }

  .vue-dropzone .dz-preview .dz-details .dz-filename:hover span {
    background-color: transparent;
    border: none;
  }

  .vue-dropzone .dz-preview .dz-progress .dz-upload {
    background: #cccccc;
  }

  .vue-dropzone .dz-preview .dz-remove {
    position: absolute;
    z-index: 30;
    color: white;
    margin-left: 15px;
    padding: 10px;
    top: inherit;
    bottom: 15px;
    border: 2px white solid;
    text-decoration: none;
    text-transform: uppercase;
    font-size: 0.8rem;
    font-weight: 800;
    letter-spacing: 1.1px;
    opacity: 0;
  }

  .vue-dropzone .dz-preview:hover .dz-remove {
    opacity: 1;
  }

  .vue-dropzone .dz-preview .dz-success-mark,
  .vue-dropzone .dz-preview .dz-error-mark {
    margin-left: auto;
    margin-top: auto;
    width: 100%;
    top: 35%;
    left: 0;
  }

  .vue-dropzone .dz-preview .dz-success-mark svg,
  .vue-dropzone .dz-preview .dz-error-mark svg {
    margin-left: auto;
    margin-right: auto;
  }

  .vue-dropzone .dz-preview .dz-error-message {
    top: calc(15%);
    margin-left: auto;
    margin-right: auto;
    left: 0;
    width: 100%;
  }

  .vue-dropzone .dz-preview .dz-error-message:after {
    bottom: -6px;
    top: initial;
    border-top: 6px solid #a92222;
    border-bottom: none;
  }

  .form[data-v-ebce4d12] {
    display: flex;
    align-content: flex-end;
  }

  .form label[data-v-ebce4d12] {
    margin-right: 1rem;
  }
</style>
